module.exports = __webpack_public_path__ + "img/two.10c99006.png";